<template>
    <div>
        <div class="row">
            <div class="col-lg-2 col-12 mt-1 mb-1 ">
                <div class="title h-100">
                    <h3>Highlights</h3>
                </div>
            </div>
            <div class="offset-lg-8 col-lg-2 col-12  mb-1">
                <button 
                    class="btn w-100 h-100" 
                    
                    @click="downloadExcel('/api/highlight/top' , null , 'Highlight Top')"
                >
                    Download Excel
                </button>
            </div>
        </div>
        <!-- {{filterOptions}} -->

        <div class="row mt-4">
            <div class="col-lg-4 col-12 mt-1 pl-3 pr-3">
                <div class="bg-white p-20" style="border-radius:10px">
                    <h4>Total Aktivitas Stok Opname</h4>
                    <span class="h1 mr-3" v-if="topData">{{topData.total_aktivitas}}</span>
                    <span class="h1 mr-3" v-else>Loading.....</span>
                    <span class="p">Aktivitas</span>
                </div>
            </div>
            <div class="col-lg-4 col-12 mt-1 pl-3 pr-3">
                <div class="bg-white p-20" style="border-radius:10px">
                    <h4>Durasi Rata-rata Aktivitas</h4>
                    <span class="h1 mr-3" v-if="topData">{{topData.rata_durasi}}</span>
                    <span class="h1 mr-3" v-else>Loading.....</span>
                    <span class="p">Menit</span>
                </div>
            </div>
            <div class="col-lg-4 col-12 mt-1 pl-3 pr-3">
                <div class="bg-white p-20" style="border-radius:10px">
                    <h4>Stok Opname Pending</h4>
                    <span class="h1 mr-3" v-if="topData">{{topData.opname_pending}}</span>
                    <span class="h1 mr-3" v-else>Loading.....</span>
                    <span class="p">Aktivitas</span>
                </div>
            </div>
        </div>

        
        <div class="row mt-5">
            <div class="col-lg-3 col-12 mt-1">
                <div class="title h-100">
                    <h3>Request Surprise Opname</h3>
                </div>
            </div>

            <div class="col-lg-9 col-12 mt-1">
                <div class="row">
                    <!-- <div class="col-lg-2 col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="[]"
                            v-model="filter.requestSurpriseOpname.lokasi"
                            placeholder="Lokasi"
                        />
                    </div> -->
                    <div class="col-lg col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="filterOptions.dealer.surpriseOpname.map(x => x.loc_code)"
                            :custom-label="opt => filterOptions.dealer.surpriseOpname.find(x => x.loc_code == opt).showName"
                            v-model="filter.requestSurpriseOpname.dealer"
                            placeholder="All Dealer (Isi 2 Kata)"
                            :internal-search="false"
                            @search-change="searchDealerSurprise"
                        />
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="filterOptions.status"
                            v-model="filter.requestSurpriseOpname.status"
                            placeholder="Status"
                        />
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="picList.map(x => x.nama_pic)"
                            v-model="filter.requestSurpriseOpname.pic"
                            selectLabel="Confirm"
                            placeholder="PIC"
                            :internal-search="false"
                            @search-change="searchPIC"
                        />
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <!-- <Multiselect 
                            :options="[]"
                            v-model="dateFilter.requestSurpriseOpname"
                            placeholder="Select Date"
                        /> -->
                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="dateFilter.requestSurpriseOpname"
                        ></flat-pickr>
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <button
                            class="btn w-100 h-100"
                            @click="downloadExcel('/api/highlight/download-report-surprise-opname' , filter.requestSurpriseOpname , 'Request Surprise Opname')"
                        >
                            Download Excel
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div class="bg-white p-20 rounded mt-3">
            <vue-universal-table 
                :api_url="'/api/highlight/report-surprise-opname'"
                :filter="filter.requestSurpriseOpname"
                :buttons="table.buttons"
                :table_striped="false"
                :update="table.update.requestSurpriseOpname"
                :fields="table.fieldsRequestSurpriseOpname"
                @onLihatDetail="showTable"
            />
        </div>

        <div class="row mt-5">
            <div class="col-lg-3 col-12 mt-1">
                <div class="title h-100">
                    <h3>Report Opname</h3>
                </div>
            </div>

            <div class="col-lg-9 col-12 mt-1">
                <div class="row">
                    <!-- <div class="col-lg-2 col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="[]"
                            v-model="filter.reportOpname.lokasi"
                            placeholder="Lokasi"
                        />
                    </div> -->
                    <div class="col-lg col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="filterOptions.dealer.reportOpname.map(x => x.loc_code)"
                            :custom-label="opt => filterOptions.dealer.reportOpname.find(x => x.loc_code == opt).showName"
                            v-model="filter.reportOpname.dealer"
                            placeholder="All Dealer (Isi 2 Kata)"
                            :internal-search="false"
                            @search-change="searchDealerOpname"
                        />
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="filterOptions.status"
                            v-model="filter.reportOpname.status"
                            placeholder="Status"
                        />
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <Multiselect 
                            :options="picList.map(x => x.nama_pic)"
                            v-model="filter.reportOpname.pic"
                            :internal-search="false"
                            placeholder="PIC"
                            selectLabel="Confirm"
                            @search-change="debouceFunction"
                        />
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <!-- <Multiselect 
                            :options="[]"
                            v-model="dateFilter.reportOpname"
                            placeholder="Select Date"
                        /> -->
                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="dateFilter.reportOpname"
                        ></flat-pickr>
                    </div>
                    <div class="col-lg col-12 mt-1 mb-1">
                        <button
                            class="btn w-100 h-100"
                            @click="downloadExcel('/api/highlight/download-report-opname' , filter.reportOpname , 'Report Opname')"
                        >
                            Download Excel
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div class="bg-white p-20 rounded mt-3">
            <vue-universal-table 
                :api_url="'/api/highlight/report-opname'"
                :filter="filter.reportOpname"
                :buttons="table.buttons"
                :table_striped="false"
                :update="table.update.reportOpname"
                :fields="table.fieldsReportOpname"
                :process_data="table.processDataReportOpname"
                @onLokasi_image="showMap"
                @onLihatDetail="showTable"
            />
        </div>
        

        <!-- <MapPopup 
            v-if="mapCoordinates"
            @closeModal="mapCoordinates = null"
            :coordinates="mapCoordinates"
        /> -->
        <MapPopup 
            :urlAPI="'/api/detail-lokasi-opname?opname_id=' + this.id"
            v-if="showMapPage"
            @closeModal="showMapPage = false"
        />

        <detailTable 
            v-if="tableCoordinates"
            @closeModal="tableCoordinates = null"
            :detailList="tableCoordinates"
        />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import debounce from 'debounce'

import detailTable from './children/detailTable.vue'

// Children
import MapPopup from '@/components/MapPopup.vue'

export default {
    metaInfo : {
        title : 'Highlights'
    },
    components : {
        Multiselect,
        MapPopup,
        detailTable
    },
    watch : {
        'dateFilter.requestSurpriseOpname' : function () {
            let split = this.dateFilter.requestSurpriseOpname.split(" to ");
            this.filter.requestSurpriseOpname.start = split[0];
            this.filter.requestSurpriseOpname.end = split.length > 1 ? split[1] : split[0];
            this.debounceMethod('requestSurpriseOpname' , this)
        },
        'dateFilter.reportOpname' : function () {
            let split = this.dateFilter.reportOpname.split(" to ");
            this.filter.reportOpname.start = split[0];
            this.filter.reportOpname.end = split.length > 1 ? split[1] : split[0];
            this.debounceMethod('reportOpname' , this)
        },
        'filter.requestSurpriseOpname' : {
            deep : true,
            handler() {
                this.debounceMethod('requestSurpriseOpname' , this)
            }
        },
        'filter.reportOpname' : {
            deep : true,
            handler() {
                this.debounceMethod('reportOpname' , this)
            }
        }
    },
    created () {
		this.debouceFunction = debounce((query) => {
			this.picList = [{
				id : 'Loading.....',
				name : 'Loading.....'
			}]
			this.searchPIC(query)
		} , 
		1000)

        this.searchPIC('')
	},
    data () {
        let startDate = new moment().startOf('month').format('Y-MM-DD HH:mm');
        let endDate = new moment().endOf('month').format('Y-MM-DD HH:mm')
        
        return {
            id : null,
            showMapPage : false,
            rangePickr: {
                mode: 'range',
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "M d, Y",
                altInputClass: 'form-control input elegant-flatpickr'
            },
            dateFilter : {
                requestSurpriseOpname : `${startDate} to ${endDate}`,
                reportOpname : `${startDate} to ${endDate}`
            },
            topData : null,
            mapCoordinates : null,
            tableCoordinates : null,
            picList : [],
            filter : {
                requestSurpriseOpname : {
                    // lokasi : '',
                    status : '',
                    pic : '',
                    start : startDate,
                    end : endDate,
                    dealer : ''
                },
                reportOpname : {
                    // lokasi : '',
                    status : '',
                    pic : '',
                    start : startDate,
                    end : endDate,
                    dealer : ''
                },
            },
            table : {
                buttons : [{
                    title : 'LihatDetail',
                    class : 'btn color-space-blue',
                    variable : 'id'
                }],
                update : {
                    requestSurpriseOpname : 0,
                    reportOpname : 0
                },
                fieldsRequestSurpriseOpname : [{
                    title : 'Dealer Code',
                    variable : 'dealer'
                } , {
                    title : 'Dealer Name',
                    variable : 'nama_dealer'
                }, {
                    title : 'Tanggal Request',
                    variable : 'tgl_request'
                }, {
                    title : 'Target Mulai',
                    variable : 'target_mulai'
                }, {
                    title : 'Tanggal Mulai',
                    variable : 'tgl_mulai'
                }, {
                    title : 'Tanggal Selesai',
                    variable : 'tgl_selesai'
                }, {
                    title : 'PIC',
                    variable : 'nama_pic'
                }, {
                    title : 'Duration',
                    variable : 'durasi'
                }, {
                    title : 'Status',
                    variable : 'status',
                    style_condition : {
                        'In Progress' : 'color : #C6A700',
                        'Done' : 'color : #00B14B',
                        'Open' : 'color : #E02525',
                        'Expired' : 'color:#A3A3A3',
                    }
                }],
                fieldsReportOpname : [{
                    title : 'Dealer Code',
                    variable : 'dealer'
                } , {
                    title : 'Dealer Name',
                    variable : 'nama_dealer'
                }, {
                    title : 'Tanggal Mulai',
                    variable : 'tgl_mulai'
                }, {
                    title : 'Tanggal Selesai',
                    variable : 'tgl_selesai'
                }, {
                    title : 'PIC',
                    variable : 'nama_pic'
                }, {
                    title : 'Duration',
                    variable : 'durasi'
                }, {
                    title : 'Jumlah Unit',
                    variable : 'jumlah_unit'
                }, {
                    title : 'Status',
                    variable : 'status',
                    style_condition : {
                        'In Progress' : 'color : #C6A700',
                        'Done' : 'color : #00B14B',
                        'Open' : 'color : #E02525',
                        'Expired' : 'color:#A3A3A3',
                    }
                }, {
                    title : 'Location',
                    variable : 'lokasi_image',
                    is_image : true,
                    emit_variable : 'id'
                }],
                processDataReportOpname : `
                    for(var i = 0 ; i < data.length ; i++) {
                        data[i].lokasi_image = '${require('@/assets/img/google-maps.svg')}'
                    }
                `,
            },
            
            // filterOptions : this.$store.getters.getFilterOptions,
            filterOptions : {
                status : this.$store.getters.getFilterOptions.status,
                dealer : {
                    reportOpname : [],
                    surpriseOpname : []
                }
            },
            sampleData : {
                requestSurpriseOpname : [{
                    dealer : 'Dealer X',
                    tanggal_request : '02 May 2022, 17:00',
                    target_mulai : '03 May 2022, 18:00',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_request : '02 May 2022, 17:00',
                    target_mulai : '03 May 2022, 18:00',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_request : '02 May 2022, 17:00',
                    target_mulai : '03 May 2022, 18:00',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_request : '02 May 2022, 17:00',
                    target_mulai : '03 May 2022, 18:00',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_request : '02 May 2022, 17:00',
                    target_mulai : '03 May 2022, 18:00',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    status : 'Open',
                }],
                reportOpname : [{
                    dealer : 'Dealer X',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    jumlah_unit : 3,
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    lokasi : 'Maps ICON (WIP)',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    jumlah_unit : 3,
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    lokasi : 'Maps ICON (WIP)',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    jumlah_unit : 3,
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    lokasi : 'Maps ICON (WIP)',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    jumlah_unit : 3,
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    lokasi : 'Maps ICON (WIP)',
                    status : 'Open',
                },{
                    dealer : 'Dealer X',
                    tanggal_mulai : '04 May 2022 13:00',
                    tanggal_selesai : '07 May 2022 19:00',
                    jumlah_unit : 3,
                    pic : 'Sukma, Fitri',
                    durasi : '3 Hari 2 Jam',
                    lokasi : 'Maps ICON (WIP)',
                    status : 'Open',
                }]
            }
        }
    },
    mounted () {
        this.loadTopApi ()
    },
    methods : {
        async searchDealerOpname (query) {
            let dealerList = await this.$store.getters.getDealer()
            dealerList = dealerList.filter(x => x.showName.toLowerCase().includes(query.toLowerCase()) && query.length > 1)
            this.filterOptions.dealer.reportOpname = dealerList
            
            
        },
        async searchDealerSurprise (query) {
            let dealerList = await this.$store.getters.getDealer()
            dealerList = dealerList.filter(x => x.showName.toLowerCase().includes(query.toLowerCase()) && query.length > 1)
            this.filterOptions.dealer.surpriseOpname = dealerList
        },
        async searchPIC (query) {
            //api/pic?search=<pic name> 
            try {
                let response = await this.$http.get('/api/pic?search=' + query)
                let data = response.data.data

                this.$set(this , 'picList' , data)
            }
            catch(err) {
                console.log(err)
            }
        },
        showMap (id) {
            this.showMapPage = true
            this.id = id
            // this.$http.get('/api/detail-lokasi-opname?opname_id=' + id)
            // .then((resp) => {
            // let data = resp.data.data
            //     // console.log(data)

            //     this.mapCoordinates = data
            // })
            // .catch((err) => {
            //     console.log(err)
            // })
        },
        showTable (id) {
            // this.$http.get('/api/detail-lokasi-opname?opname_id=' + id)
            // .then((resp) => {
            //     let data = resp.data.data
            //     // console.log(data)

            //     this.tableCoordinates = data
            // })
            // .catch((err) => {
            //     console.log(err)
            // })
            this.$router.push({name : 'StockOpnameDetail' , params : {id : id} , query : {from : 'Highlight'} });
        },
        loadTopApi () {
            this.$http.get('/api/highlight/top')
            .then((resp) => {
                this.topData = resp.data.data
            })
            .catch((err) => {
                console.log(err)
            })
        },
        downloadExcel (url , filter , title) {
            if(filter)
                url += '?' + this.initialiseFilter(filter)

            this.$http.get(url)
            .then((resp) => {
                let data = resp.data.data
                if(!Array.isArray(data)) data = [data]

                this.exportExcel(data , title)
            })
            .catch((err) => {
                console.log(err)
            })
        },
        debounceMethod : debounce((value , vm) => {
            vm.table.update[value]++;
            console.log(vm.table.update[value])
        } , 300)
    }
}
</script>

<style scoped>
    * {
        color :#5D5D5D;
    }
</style>